var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

module.exports = canUseDOM;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/can-use-dom/index.js
// module id = 534
// module chunks = 168707334958949